import { useContext } from 'react';
import { SessionContext, } from '@wix/da-react-context/pkg/SessionContext';
/** returns the first promo in publicSessions.promos if any */
export function useCurrentPromo() {
    var promos = useContext(SessionContext).promos;
    var currentPromo = promos === null || promos === void 0 ? void 0 : promos[0];
    return currentPromo;
}
//# sourceMappingURL=useCurrentPromo.js.map